module.exports = __webpack_public_path__ + "img/小野兼.dd143596.jpg";